import { Box, VStack } from '@chakra-ui/react';

import GitHubButton from 'components/GitHubButton';
import Link from 'components/Link';
import Modal from 'components/Modal';
import Text from 'components/Text';
import { IModal } from 'types/frontend';

interface IRedirectModalProps extends IModal {
  isSessionExpired?: boolean;
}

export const RedirectModal = ({ isOpen, onClose, isSessionExpired }: IRedirectModalProps) => {
  return (
    <Modal size="md" isOpen={isOpen} onClose={onClose} header={null} footer={null}>
      <VStack spacing={5} py={4} px={2}>
        <VStack spacing={1}>
          <Text fontSize="xLarge" fontWeight="bold">
            {isSessionExpired ? 'Session Expired' : 'Welcome to BigDevSoon'}
          </Text>
          <Text fontWeight="regular" opacity="secondary" textAlign="center">
            {isSessionExpired
              ? 'Your session has expired. Please sign in again to continue.'
              : 'Sign in to access all features.'}
          </Text>
        </VStack>

        <GitHubButton text="Sign in with GitHub" />

        <Box w="100%" h="1px" bg="whiteAlpha.100" />

        <Text fontWeight="regular" opacity="tertiary" fontSize="small" textAlign="center">
          Try the code editor or explore resources on{' '}
          <Link href="https://bigdevsoon.me" fontWeight="regular" fontSize="small">
            bigdevsoon.me
          </Link>
        </Text>
      </VStack>
    </Modal>
  );
};
